var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        visible: _vm.visible,
        "show-footer": false,
        title: "Gantt Ayarları",
        large: "",
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "gantt-settings-modal" },
        [
          _c("a-form", { attrs: { form: _vm.form, layout: "vertical" } }, [
            _c(
              "div",
              { staticClass: "settings-section" },
              [
                _c("h4", [_vm._v("Zorunlu Alanlar")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Görev Adı Field" } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "taskNameField",
                              {
                                initialValue: _vm.widget.settings.taskNameField,
                                rules: [
                                  {
                                    required: true,
                                    message: "Görev adı field seçiniz",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'taskNameField',\n                            {\n                                initialValue: widget.settings.taskNameField,\n                                rules: [{ required: true, message: 'Görev adı field seçiniz' }],\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder: "Görev adı field seçiniz",
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                        },
                      },
                      _vm._l(_vm.stringFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Başlangıç Tarihi Field" } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "startDateField",
                              {
                                initialValue:
                                  _vm.widget.settings.startDateField,
                                rules: [
                                  {
                                    required: true,
                                    message: "Başlangıç tarihi field seçiniz",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'startDateField',\n                            {\n                                initialValue: widget.settings.startDateField,\n                                rules: [{ required: true, message: 'Başlangıç tarihi field seçiniz' }],\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder: "Başlangıç tarihi field seçiniz",
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                        },
                      },
                      _vm._l(_vm.dateFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Bitiş Tarihi Field" } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "endDateField",
                              {
                                initialValue: _vm.widget.settings.endDateField,
                                rules: [
                                  {
                                    required: true,
                                    message: "Bitiş tarihi field seçiniz",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n                            'endDateField',\n                            {\n                                initialValue: widget.settings.endDateField,\n                                rules: [{ required: true, message: 'Bitiş tarihi field seçiniz' }],\n                            },\n                        ]",
                          },
                        ],
                        attrs: {
                          placeholder: "Bitiş tarihi field seçiniz",
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                        },
                      },
                      _vm._l(_vm.dateFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "settings-section" },
              [
                _c("h4", [_vm._v("Opsiyonel Alanlar")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "İlerleme Field (%)" } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "progressField",
                              {
                                initialValue: _vm.widget.settings.progressField,
                              },
                            ],
                            expression:
                              "['progressField', { initialValue: widget.settings.progressField }]",
                          },
                        ],
                        attrs: {
                          placeholder: "İlerleme field seçiniz",
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                          "allow-clear": "",
                        },
                      },
                      _vm._l(_vm.numberFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Durum Field" } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "statusField",
                              { initialValue: _vm.widget.settings.statusField },
                            ],
                            expression:
                              "['statusField', { initialValue: widget.settings.statusField }]",
                          },
                        ],
                        attrs: {
                          placeholder: "Durum field seçiniz",
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                          "allow-clear": "",
                        },
                      },
                      _vm._l(_vm.dropdownFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Atanan Kişi Field" } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "assigneeField",
                              {
                                initialValue: _vm.widget.settings.assigneeField,
                              },
                            ],
                            expression:
                              "['assigneeField', { initialValue: widget.settings.assigneeField }]",
                          },
                        ],
                        attrs: {
                          placeholder: "Atanan kişi field seçiniz",
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                          "allow-clear": "",
                        },
                      },
                      _vm._l(_vm.userFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Öncelik Field" } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "priorityField",
                              {
                                initialValue: _vm.widget.settings.priorityField,
                              },
                            ],
                            expression:
                              "['priorityField', { initialValue: widget.settings.priorityField }]",
                          },
                        ],
                        attrs: {
                          placeholder: "Öncelik field seçiniz",
                          "show-search": "",
                          "filter-option": _vm.filterOption,
                          "allow-clear": "",
                        },
                      },
                      _vm._l(_vm.dropdownFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(field.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "settings-section" },
              [
                _c("h4", [_vm._v("Görünüm Ayarları")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Görünüm Modu" } },
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "viewMode",
                              {
                                initialValue:
                                  _vm.widget.settings.viewMode || "month",
                              },
                            ],
                            expression:
                              "['viewMode', { initialValue: widget.settings.viewMode || 'month' }]",
                          },
                        ],
                        attrs: { placeholder: "Görünüm modu seçiniz" },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "day" } }, [
                          _vm._v("Günlük"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "week" } }, [
                          _vm._v("Haftalık"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "month" } }, [
                          _vm._v("Aylık"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "quarter" } }, [
                          _vm._v("Çeyreklik"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "year" } }, [
                          _vm._v("Yıllık"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "a-checkbox",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "showProgress",
                              {
                                initialValue: _vm.$_.get(
                                  _vm.widget,
                                  "settings.customization.showProgress",
                                  true
                                ),
                                valuePropName: "checked",
                              },
                            ],
                            expression:
                              "[\n                            'showProgress',\n                            {\n                                initialValue: $_.get(widget, 'settings.customization.showProgress', true),\n                                valuePropName: 'checked',\n                            },\n                        ]",
                          },
                        ],
                      },
                      [
                        _vm._v(
                          "\n                        İlerleme göster\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "a-checkbox",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "showWeekends",
                              {
                                initialValue: _vm.$_.get(
                                  _vm.widget,
                                  "settings.customization.showWeekends",
                                  true
                                ),
                                valuePropName: "checked",
                              },
                            ],
                            expression:
                              "[\n                            'showWeekends',\n                            {\n                                initialValue: $_.get(widget, 'settings.customization.showWeekends', true),\n                                valuePropName: 'checked',\n                            },\n                        ]",
                          },
                        ],
                      },
                      [
                        _vm._v(
                          "\n                        Hafta sonlarını göster\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "a-checkbox",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "showToday",
                              {
                                initialValue: _vm.$_.get(
                                  _vm.widget,
                                  "settings.customization.showToday",
                                  true
                                ),
                                valuePropName: "checked",
                              },
                            ],
                            expression:
                              "[\n                            'showToday',\n                            {\n                                initialValue: $_.get(widget, 'settings.customization.showToday', true),\n                                valuePropName: 'checked',\n                            },\n                        ]",
                          },
                        ],
                      },
                      [
                        _vm._v(
                          "\n                        Bugün çizgisini göster\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _c(
                "SupsisButton",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v("İptal")]
              ),
              _vm._v(" "),
              _c(
                "SupsisButton",
                { attrs: { primary: "" }, on: { click: _vm.handleSave } },
                [_vm._v("Kaydet")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }